import React from "react";
import classes from './siteButton.module.css';

const SiteLink = (props) => {
    return(
        <a href={props.link} type="button" className={classes.siteLink}>{props.title}</a>
    )
} 

export default SiteLink;